const Bugsnag = require('@bugsnag/js')
const BugsnagPluginExpress = require('@bugsnag/plugin-express')
const BugsnagPluginReact = require('@bugsnag/plugin-react')

module.exports = Bugsnag.start({
  apiKey: '8f8436b2548b5aadbca07664aa728c43',
  plugins: [BugsnagPluginExpress, new BugsnagPluginReact()],
  releaseStage: 'v1',
  appType: 'production',
})
